var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5Secforward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_+5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24_Specific-player---matches---full-video",
    transform: "translate(-711, -779)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(631, 779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_+5",
    transform: "translate(80, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 5,
    transform: "translate(6, 8)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 2.30820996 0 2.99461642 1.38555265 2.99461642 1.38555265 4.34051144 2.09573542 4.34051144 2.09573542 2.99461642 3.48128808 2.99461642 3.48128808 2.30820996 2.09573542 2.30820996 2.09573542 0.969044415 1.38555265 0.969044415 1.38555265 2.30820996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09225413,5 C7.22715405,5 8,4.27321669 8,3.20995962 C8,2.24091521 7.32463011,1.57469717 6.30809399,1.57469717 C5.95996519,1.57469717 5.65361184,1.66218035 5.40992167,1.81695828 L5.68146214,0.794078062 L7.69364665,0.794078062 L7.69364665,0 L5.04090513,0 L4.41427328,2.57738896 L5.20104439,2.73889637 C5.38207137,2.48317631 5.73716275,2.29475101 6.12706701,2.29475101 C6.73977372,2.29475101 7.0948651,2.68506057 7.0948651,3.25706595 C7.0948651,3.85598923 6.71192341,4.23283984 6.11314186,4.23283984 C5.54917319,4.23283984 5.20800696,3.90309556 5.20800696,3.34454913 L4.32375979,3.34454913 C4.32375979,4.34051144 5.02697998,5 6.09225413,5 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1673469,9.16734694 C18.7061224,9.16734694 18.3346939,9.53877551 18.3346939,10 C18.3346939,14.5959184 14.5959184,18.3346939 10,18.3346939 C5.40408163,18.3346939 1.66530612,14.5959184 1.66530612,10 C1.66530612,5.40408163 5.40408163,1.66530612 10,1.66530612 C12.5102041,1.66530612 14.8367347,2.77142857 16.4122449,4.67346939 L13.5346939,4.67346939 C13.0734694,4.67346939 12.7020408,5.04489796 12.7020408,5.50612245 C12.7020408,5.96734694 13.0734694,6.33877551 13.5346939,6.33877551 L18.2122449,6.33877551 C18.6734694,6.33877551 19.044898,5.96734694 19.044898,5.50612245 L19.044898,0.832653061 C19.044898,0.371428571 18.6734694,0 18.2122449,0 C17.7510204,0 17.3795918,0.371428571 17.3795918,0.832653061 L17.3795918,3.24081633 C15.4979592,1.1877551 12.8489796,0 10,0 C4.48571429,0 0,4.48571429 0,10 C0,15.5142857 4.48571429,20 10,20 C15.5142857,20 20,15.5142857 20,10 C20,9.53877551 19.6285714,9.16734694 19.1673469,9.16734694 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Secforward);
export default __webpack_public_path__ + "static/media/5secforward.cca817b9794b92dfd99ac20e50e4bdf5.svg";
export { ForwardRef as ReactComponent };